import ScrollAnimation from "react-animate-on-scroll";
import { Wrapper } from "./styles";

interface ComodidadeProps {
  comodidadeImg: any;
  textSup: string;
  textSub: string;
}

export function Comodidade({
  comodidadeImg,
  textSup,
  textSub,
}: ComodidadeProps) {
  return (
    <Wrapper>
      <ScrollAnimation animateIn="animate__zoomIn">
        <img className="comodidade-img" src={comodidadeImg} alt="Comodidade" />
      </ScrollAnimation>
      <div>
        <h3>{textSup}</h3>
        <p>{textSub}</p>
      </div>
    </Wrapper>
  );
}
